import React, { useEffect, useState, useRef } from "react";
import { Globe } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const LanguageSelector = ({ position = "bottom-right", className = "" }) => {
  const [mounted, setMounted] = useState(false);
  const wrapperRef = useRef(null);

  const {
    language,
    showLanguageMenu,
    toggleLanguageMenu,
    closeLanguageMenu,
    changeLanguage,
    t,
  } = useLanguage();

  useEffect(() => {
    setMounted(true);
  }, []);

  // ✅ Outside click handler (FIXED)
  useEffect(() => {
    if (!mounted) return;

    const handleClickOutside = (event) => {
      if (
        showLanguageMenu &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        closeLanguageMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLanguageMenu, closeLanguageMenu, mounted]);

  const getPositionClasses = () => {
    switch (position) {
      case "top-right":
        return "top-4 right-4";
      case "top-left":
        return "top-4 left-4";
      case "bottom-left":
        return "bottom-20 left-4";
      case "bottom-right":
      default:
        return "bottom-20 right-4";
    }
  };

  const getLanguageDisplay = () => {
    switch (language) {
      case "EN":
        return "🇬🇧 EN";
      case "BN":
        return "🇧🇩 BN";
      case "HN":
        return "🇮🇳 HN";
      default:
        return "🇬🇧 EN";
    }
  };

  if (!mounted) return null;

  return (
    <div
      ref={wrapperRef}
      className={`fixed ${getPositionClasses()} z-50 language-selector ${className}`}
    >
      <div className="relative">
        
        {/* 🌐 Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleLanguageMenu();
          }}
          className="flex items-center gap-2 px-3 py-2 bg-white dark:bg-gray-800 rounded-full shadow-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 backdrop-blur-sm"
        >
          <Globe className="w-4 h-4 text-gray-600 dark:text-gray-400" />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {getLanguageDisplay()}
          </span>
        </button>

        {/* ⬇️ Dropdown (NOW OPENS DOWNWARD) */}
        {showLanguageMenu && (
          <div className="absolute top-full right-0 mt-2 w-40 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-20 overflow-hidden">
            
            {/* English */}
            <button
              onClick={() => changeLanguage("EN")}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-gray-700 ${
                language === "EN"
                  ? "bg-blue-50 dark:bg-blue-900/20 text-blue-600"
                  : "text-gray-700 dark:text-gray-300"
              }`}
            >
              🇬🇧 {t.english}
            </button>

            {/* Bengali */}
            <button
              onClick={() => changeLanguage("BN")}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-gray-700 ${
                language === "BN"
                  ? "bg-blue-50 dark:bg-blue-900/20 text-blue-600"
                  : "text-gray-700 dark:text-gray-300"
              }`}
            >
              🇧🇩 {t.bengali}
            </button>

            {/* Hindi */}
            <button
              onClick={() => changeLanguage("HN")}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-100 dark:hover:bg-gray-700 ${
                language === "HN"
                  ? "bg-blue-50 dark:bg-blue-900/20 text-blue-600"
                  : "text-gray-700 dark:text-gray-300"
              }`}
            >
              🇮🇳 {t.hindi}
            </button>

          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;